import { render, staticRenderFns } from "./ModalUserLock.vue?vue&type=template&id=47e96645&"
import script from "./ModalUserLock.vue?vue&type=script&lang=js&"
export * from "./ModalUserLock.vue?vue&type=script&lang=js&"
import style0 from "./ModalUserLock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports